import { AlertCircle, Users } from "lucide-react";
import {
    Alert,
    AlertDescription,
    AlertTitle,
} from "@/components/ui/alert";

const LargeGroupsAlerts = () => {
    const alerts: any = [];
    // const alerts: any = [
    //     {
    //         title: "Overloaded Group Detected",
    //         description: "A group with more than 10 passengers was detected at 14:32 near Terminal 1.",
    //     },
    //     {
    //         title: "Multiple Large Groups Pending Dispatch",
    //         description: "There are 3 large groups waiting for vehicle assignment.",
    //     },
    //     {
    //         title: "Group Split Warning",
    //         description: "A single group was split into 2 vehicles due to lack of capacity.",
    //     },
    //     {
    //         title: "Delayed Pickup for Large Group",
    //         description: "Group scheduled at 13:15 is still waiting for pickup. Delay: 20 minutes.",
    //     },
    // ];

    return (
        <div className="space-y-4">
            <div className="flex items-center space-x-2">
                <Users className="text-gray-500 dark:text-gray-400" />
                <h2 className="text-lg font-semibold">
                    Large Group Alerts ({alerts.length})
                </h2>
            </div>

            {alerts.length === 0 ? (
                <Alert
                    variant="default"
                    className="bg-gray-50 border-gray-200 text-gray-800 
                               dark:bg-gray-900 dark:border-gray-700 dark:text-gray-200"
                >
                    <AlertCircle className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                    <AlertTitle>No Alerts</AlertTitle>
                    <AlertDescription>
                        Currently there are no large group alerts.
                    </AlertDescription>
                </Alert>
            ) : (
                <div className="space-y-2">
                    {alerts.map((alert: any, index: number) => (
                        <Alert
                            key={index}
                            variant="default"
                            className="bg-gray-50 border-gray-200 text-gray-800 
                                       dark:bg-gray-900 dark:border-gray-700 dark:text-gray-200"
                        >
                            <AlertCircle className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                            <AlertTitle>{alert.title}</AlertTitle>
                            <AlertDescription>{alert.description}</AlertDescription>
                        </Alert>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LargeGroupsAlerts;
